'use strict';

function addMonths(iso, months) {
  const [y, m, d] = String(iso).split('-').map(Number);
  const base = new Date(Date.UTC(y, m - 1 + months, 1));
  const lastDay = new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth() + 1, 0)).getUTCDate();
  base.setUTCDate(Math.min(d, lastDay));
  return base.toISOString().slice(0, 10);
}

function parseIcd10(raw) {
  return String(raw || '')
    .split(/[,\s]+/)
    .map(s => s.trim())
    .filter(Boolean);
}

function validateForm(state) {
  const errors = [];
  if (!state || typeof state !== 'object') return { ok: false, errors: ['invalid form'] };
  if (!state.pinnedPatient || !state.pinnedPatient.elationId) errors.push('Pick a patient.');
  if (state.homeboundAttested !== true) errors.push('Confirm the patient is homebound.');
  const tests = Array.isArray(state.tests) ? state.tests : [];
  const real = tests.filter(t => t && (t.name || '').trim());
  if (real.length === 0) errors.push('Add at least one test with a name.');
  // Quest needs ICD-10s but pools them across the order — require at least one
  // overall rather than one per test (matches real homebound orders).
  if (real.length > 0 && !real.some(t => parseIcd10(t.icd10).length > 0)) {
    errors.push('Enter at least one ICD-10 code.');
  }
  real.forEach((t, i) => {
    const label = (t.name || `test ${i + 1}`).trim();
    // Standing-order trio (mirrors server validate.js): frequency + start +
    // finish together, or none — a cadence with no window (or the reverse)
    // is an order Quest can't act on.
    const standingBits = [(t.frequency || '').trim(), t.startDate, t.finishDate].filter(Boolean).length;
    if (standingBits > 0 && standingBits < 3) {
      errors.push(`${label}: pick a frequency and both dates for a standing order (or clear all three for a one-time draw).`);
    }
    if (t.startDate && t.finishDate && t.finishDate > addMonths(t.startDate, 6)) {
      errors.push(`${label}: standing order may not exceed 6 months.`);
    }
  });
  return { ok: errors.length === 0, errors };
}

function buildPayload(state) {
  const tests = (state.tests || [])
    .filter(t => t && (t.name || '').trim())
    .map(t => ({
      name: (t.name || '').trim(),
      testNumber: (t.testNumber || '').trim() || undefined,
      icd10: parseIcd10(t.icd10),
      fasting: t.fasting === true,
      frequency: (t.frequency || '').trim(),
      startDate: t.startDate || '',
      finishDate: t.finishDate || '',
    }));
  return {
    elationPatientId: state.pinnedPatient ? Number(state.pinnedPatient.elationId) : null,
    homeboundAttested: state.homeboundAttested === true,
    tests,
    duplicateRecipients: [],
  };
}

// Standard mobile-phlebotomy standing-order cadences — the realistic set
// under the 6-month order cap. The UI offers these as a picker (with a
// custom escape hatch); the API keeps accepting free text (voice path).
const FREQUENCY_OPTIONS = ['Weekly', 'Every 2 weeks', 'Monthly', 'Every 2 months', 'Every 3 months'];

module.exports = { validateForm, buildPayload, parseIcd10, addMonths, FREQUENCY_OPTIONS };
